import { Box, Tag } from '@factorialco/deprecated-design-system'
import { some } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { useGetTrialEmployees } from 'modules/employees/hooks/useGetTrialEmployees'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
}
interface TrialEmployee {
  id: number
  accessId: number
  companyId: number
  status: string
}

const isTrialEmployee = (employee: Employee, trialEmployees: TrialEmployee[]) => {
  return some(trialEmployees, { accessId: employee.attributes.access_id })
}

const TrialEmployeeTag = ({ employee }: Props) => {
  const { loading, trialEmployees } = useGetTrialEmployees()

  if (loading) return null
  if (trialEmployees.length === 0 || !isTrialEmployee(employee, trialEmployees)) {
    return null
  }

  return (
    <Box flexDirection="row" paddingY="s4" paddingX="s16">
      <Box gap="s16" flexDirection="row">
        <Tag leftItem="circle" type="champagne" showCircle>
          {i18n.t('trial_employees.trial_employee_tag')}
        </Tag>
      </Box>
    </Box>
  )
}

export default TrialEmployeeTag
